import { Box, Skeleton } from '@mui/material';
import React from 'react';

const PossibleMatchesTitleSkeleton = () => {
    return (
        <Box sx={{}}>
            {/* SEARCH_INFO BAR */}
            <Box sx={{ mb: 6, width: '1017px' }}>
                <Skeleton sx={{ width: '1012px', height: 40, mb: 2 }} />
                <Skeleton sx={{ width: '371px', height: 40 }} />
            </Box>

            {/* CARDS ROWS */}
            {[...Array(3)].map((_, i) => (
                <Box key={i} sx={{ width: '1017px', mb: 5 }}>
                    {/* PLATFORM ICON + FILTERS */}
                    <Box sx={{ display: 'flex', mb: 5 }}>
                        <Skeleton sx={{ width: '24px', height: '24px' }} />
                        <Skeleton sx={{ width: '90px', height: '24px', ml: 3 }} />
                        <Skeleton sx={{ width: '90px', height: '24px', ml: 4 }} />
                    </Box>
                    {/* CARDS */}
                    <Box style={{ display: 'flex' }}>
                        {[...Array(6)].map((_, j) => (
                            <Skeleton key={j} sx={{ width: '154px', height: '256px', mr: 2 }} />
                        ))}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

export default PossibleMatchesTitleSkeleton;
